import { Reveal } from "./Reveal";
import { waLink } from "../lib/api";
import { MessageCircle } from "lucide-react";

export default function ChiSiamo() {
    return (
        <section id="chi-siamo" className="py-24 md:py-32 border-t border-line bg-card/40 scroll-mt-16">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="max-w-3xl">
                    <Reveal>
                        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-primary">
                            Chi siamo
                        </p>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[0.95]">
                            Trent'anni di cura,
                            <br />
                            una sola famiglia.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="mt-6 text-muted-foreground leading-relaxed">
                            La CG Service SRL nasce trent'anni fa ad opera del
                            signor Giuseppe Cirigliano, con un obiettivo
                            preciso: offrire un servizio efficace ed efficiente
                            nella vendita di ricambi per grandi e piccoli
                            elettrodomestici, prestando particolare attenzione
                            alla cura del cliente e alla risoluzione delle più
                            diverse problematiche del settore.
                        </p>
                    </Reveal>
                    <Reveal delay={0.22}>
                        <p className="mt-4 text-muted-foreground leading-relaxed">
                            Quell'esperienza ci ha permesso di arrivare a un
                            assortimento di circa 12.000 prodotti, riguardanti
                            tutti i marchi in commercio. Per offrire un
                            servizio ancora più completo, abbiamo investito
                            nella vendita di elettrodomestici dei migliori
                            brand e in questo portale, dove puoi ordinare
                            su WhatsApp e saldare direttamente in negozio.
                        </p>
                    </Reveal>
                    <Reveal delay={0.28} className="mt-8 flex items-center gap-5">
                        <div className="h-px w-14 bg-primary" />
                        <div>
                            <p className="font-display text-xl font-bold tracking-tight">
                                Giuseppe Cirigliano
                            </p>
                            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mt-1">
                                Fondatore · CG Service SRL
                            </p>
                        </div>
                    </Reveal>
                    <Reveal delay={0.34}>
                        <a
                            data-testid="chi-siamo-whatsapp"
                            href={waLink("Ciao CG Service, vorrei alcune informazioni!")}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-9 inline-flex items-center gap-3 border border-line px-6 py-3.5 font-display font-bold text-sm tracking-tight hover:border-primary hover:text-primary transition-colors duration-200"
                        >
                            <MessageCircle className="h-4 w-4" />
                            Scrivici su WhatsApp
                        </a>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}